import React, { useEffect, useState } from "react";
import "../styles/styles.css";

const ShowRecord = ({ token }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchColumn, setSearchColumn] = useState("przyrzad_pomiarowy"); // Default column to search
  const [searchTerm, setSearchTerm] = useState(""); // Search term

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://api.wiczka.eu/api/data/", {
          method: "GET",
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Błąd podczas pobierania danych");
        }

        const data = await response.json();
        setRecords(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  // Handle search column change
  const handleSearchColumnChange = (e) => {
    setSearchColumn(e.target.value);
  };

  // Handle search term change
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter records based on the selected column and search term
  const filteredRecords = records.filter((record) =>
    record[searchColumn]
      ? record[searchColumn]
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      : false
  );

  // Sort records by ID in descending order (newest first)
  const sortedRecords = filteredRecords.sort((a, b) => b.id - a.id);

  return (
    <div className="show-records-container">
      <h2>Lista Świadectw Legalizacji</h2>

      {/* Search Box Section */}
      <div className="search-box">
        <select
          value={searchColumn}
          onChange={handleSearchColumnChange}
          className="search-column-dropdown"
        >
          <option value="przyrzad_pomiarowy">Przyrząd pomiarowy</option>
          <option value="miejsce_uzytkowania">Miejsce użytkowania</option>
          <option value="okres_waznosci_legalizacji">Okres ważności legalizacji</option>
          <option value="data_waznosci">Data ważności</option>
          <option value="data_wystawienia">Data wystawienia</option>
          <option value="emails">Adresy e-mail</option>
        </select>

        <input
          type="text"
          placeholder="Wyszukaj..."
          value={searchTerm}
          onChange={handleSearchTermChange}
          className="search-input"
        />
      </div>

      {/* Loading or Error Message */}
      {loading ? (
        <p>Ładowanie danych...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <table className="records-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Data ważności</th>
              <th>Adresy e-mail</th>
              <th>Przyrząd pomiarowy</th>
              <th>Okres ważności legalizacji</th>
              <th>Miejsce użytkowania</th>
              <th>Data wystawienia</th>
              <th>Data zapisu</th>
            </tr>
          </thead>
          <tbody>
            {sortedRecords.length > 0 ? (
              sortedRecords.map((record) => (
                <tr key={record.id}>
                  <td>{record.id}</td>
                  <td>{record.data_waznosci}</td>
                  <td>{record.emails}</td>
                  <td>{record.przyrzad_pomiarowy}</td>
                  <td>{record.okres_waznosci_legalizacji}</td>
                  <td>{record.miejsce_uzytkowania}</td>
                  <td>{record.data_wystawienia}</td>
                  <td>{record.data_zapisu_danych}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9">Brak wyników</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ShowRecord;
